import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { GET_AREAS } from "../graphql/Queries/AreaQuery";
import { DELETE_AREA } from "../graphql/Mutations/AreaMutation";
import i18next from "i18next";
import {
  GET_BLACK_LISTS,
  GET_BLACK_LISTS_HISTORY,
} from "../graphql/Queries/BlackListQuery";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  MODIFY_BLACK_LIST,
  UNLOCK_BLACK_LIST,
} from "../graphql/Mutations/BlackListMutation";
import Fancybox from "../components/Fancybox";

export const BlackList = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [histories, setHistories] = useState([]);

  const { data } = useQuery(GET_BLACK_LISTS, {
    fetchPolicy: "no-cache",
  });
  const [getHistory] = useLazyQuery(GET_BLACK_LISTS_HISTORY);
  const [unlock] = useMutation(UNLOCK_BLACK_LIST);

  useEffect(() => {
    if (data) {
      setItems(data.blackList);
    }
  }, [data]);

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Черный список"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "created_at", label: "Первая блокировка" },
                  { key: "phone", label: "Телефон" },
                  { key: "type", label: "Тип" },
                  {
                    key: "status",
                    label: "Состояние",
                    callback: (status) => {
                      return status
                        ? t("Заблокирован")
                        : t("Блокировка отключена");
                    },
                  },
                  { key: "comment", label: "Комментарий" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={false}
                buttons={[
                  {
                    onClick: (row) => {
                      getHistory({
                        variables: {
                          phone: row.phone,
                        },
                      })
                        .then((response) => {
                          setHistories(response.data.blackListHistory);
                          setShowModal(true);
                        })
                        .catch((error) => {
                          toast.error(t("Ошибка получения истории"));
                        });
                    },
                    icon: "mdi mdi-book-clock",
                    title: "История",
                  },
                  {
                    onClick: (row) => {
                      unlock({
                        variables: {
                          id: Number(row.id),
                        },
                      })
                        .then((response) => {
                          setItems(response.data.unlockBlackList);
                        })
                        .catch((error) => {
                          Notification(error);
                        });
                    },
                    show: (row) => {
                      return row.status;
                    },
                    icon: "mdi mdi-lock-open",
                    title: "Разблокировать",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} size="lg">
        <Modal.Header closeButton onClick={() => setShowModal(false)}>
          <Modal.Title>{t("История блокировок")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className={"table table-striped"}>
            <thead>
              <tr>
                <td>{t("Дата блокировки")}</td>
                <td>{t("Тип")}</td>
                <td>{t("Бликоривка до")}</td>
                <td>{t("Комментарий")}</td>
                <td>{t("Действие")}</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {histories.map((item) => {
                return (
                  <tr>
                    <td>{item.created_at}</td>
                    <td>{item.type}</td>
                    <td>{item.locked_at}</td>
                    <td>{item.comment}</td>
                    <td>{item.action}</td>
                    <td>
                      <Fancybox
                        options={{
                          Carousel: {
                            infinite: false,
                          },
                        }}
                      >
                        {item.files.map((file, index) => (
                          <a
                            data-fancybox="gallery"
                            href={file}
                            className={"overlap"}
                          >
                            {index === 0 && (
                              <span className={"mdi mdi-file-image"}></span>
                            )}
                          </a>
                        ))}
                      </Fancybox>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Закрыть")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Wrapper>
  );
};
